import {SelectValueInterface} from '@interfaces/select-value.interface';
import {FormGroup} from '@angular/forms';

/**
 * Динамические поля
 */
export namespace DynamicFields {
    /**
     * Поле
     */
    export interface Field {
        /**
         * ===============================================================
         * Значения, приходящие от API
         * ===============================================================
         */

        input_type: FieldType;

        /**
         * Программное имя поля
         */
        id: string|number;

        /**
         * Метка поля (текстовая подпись)
         */
        name: string;

        /**
         * Единица измерения
         */
        measure_unit: string;

        /**
         * Обязательное ли поле
         */
        required: boolean;

        /**
         * Поле скрыто для отображения?
         */
        hidden?: boolean;

        /**
         * Значение
         */
        value?: string|number|boolean;

        /**
         * Значения для селекта, если тип поля select
         */
        select_values?: SelectValueInterface[];
    }

    export interface ParamWithForm extends Field {
        /**
         * Форма для поля.
         * Подставляется на стороне Frontend, после создания кусочка формы для поля
         */
        fbGroup?: FormGroup;
    }

    /**
     * Тип поля
     */
    export enum FieldType {
        text = 1,
        integer = 2,
        float = 3,
        boolean = 4,
        select = 5,
        hidden = 6,
    }

    export interface FieldFormValue {
        /**
         * id связи группы элементов ТУ с динамическим полем
         */
        id: number;

        /**
         *
         */
        param_id: number;

        /**
         * Значение поля
         */
        value: string|number|boolean;
    }
}
